"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLanguageTranslation = void 0;
const React = require("react");
const app_1 = require("app");
const useLanguageTranslation = (config) => {
    const { apiUrl, locationApiKey, culture, enabled = true } = config;
    const [dictionary, setDictionary] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    React.useEffect(() => {
        if (!enabled || !apiUrl || !locationApiKey || !culture) {
            setDictionary({});
            setIsLoading(false);
            setError(null);
            return;
        }
        const languageService = new app_1.LanguageService({
            apiUrl,
            locationApiKey,
            culture,
            keyMode: app_1.LocationKeyModeEnum.Code,
            prefixNeeded: true,
        });
        let isCancelled = false;
        setIsLoading(true);
        setError(null);
        languageService
            .getTranslatedLanguagesObjectByLanguageCode()
            .then(result => {
            if (isCancelled) {
                return;
            }
            result.gr = result.el; // Handle Greek language code variation
            result.sp = result.es; // Handle Spanish language code variation
            setDictionary(result || {});
        })
            .catch(loadError => {
            if (isCancelled) {
                return;
            }
            setDictionary({});
            setError(loadError instanceof Error ? loadError : new Error('Failed to load languages'));
        })
            .finally(() => {
            if (!isCancelled) {
                setIsLoading(false);
            }
        });
        return () => {
            isCancelled = true;
        };
    }, [apiUrl, locationApiKey, culture, enabled]);
    return {
        languageFilterDictionary: dictionary,
        isLoading,
        error,
    };
};
exports.useLanguageTranslation = useLanguageTranslation;
